export default __webpack_public_path__ + "static/media/question-form.d906aaf8.png";